import {
  GET_SOCIAL_ORGANIZATION_FEEDBACKS,
  GET_SOCIAL_ORGANIZATION_FEEDBACK_DETAIL,
  UPDATE_SOCIAL_ORGANIZATION_FEEDBACK,
  RESOLVE_SOCIAL_ORGANIZATION_FEEDBACK,
  REJECT_SOCIAL_ORGANIZATION_FEEDBACK,
  CLEAR_SOCIAL_ORGANIZATION_FEEDBACK_DETAIL,
} from './actionTypes';

export const actionGetSocialOrganizationFeedbacks = (payload) => ({
  payload,
  type: GET_SOCIAL_ORGANIZATION_FEEDBACKS,
});

export const actionGetSocialOrganizationFeedbackDetail = (payload) => ({
  payload,
  type: GET_SOCIAL_ORGANIZATION_FEEDBACK_DETAIL,
});

export const actionUpdateSocialOrganizationFeedback = (payload) => ({
  payload,
  type: UPDATE_SOCIAL_ORGANIZATION_FEEDBACK,
});

export const actionResolveSocialOrganizationFeedback = (payload) => ({
  payload,
  type: RESOLVE_SOCIAL_ORGANIZATION_FEEDBACK,
});

export const actionRejectSocialOrganizationFeedback = (payload) => ({
  payload,
  type: REJECT_SOCIAL_ORGANIZATION_FEEDBACK,
});

export const actionClearSocialOrganizationFeedbackDetail = () => ({
  type: CLEAR_SOCIAL_ORGANIZATION_FEEDBACK_DETAIL,
});

export default actionGetSocialOrganizationFeedbacks;
